import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import { useMutation, useQuery } from 'react-query'
import {
  directCardConfirm,
  directPaymentConfirm,
  getListCompanyCards,
  getUserProfile,
  preparePayment,
  registerPaymentDireclty
} from 'api'
import OrderForm from './OrderForm'
import { showErrorMessage } from 'utils/showMessage'
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from 'hooks'
import { isAdminPage } from 'utils/isAdminPage'
import { subscriptionsActions } from 'store/reducers/subscriptions/subscriptions'
import { Card, Radio, Space } from 'antd'
import ErrorIcon from '@mui/icons-material/Error'
import CustomButton from 'components/atoms/CustomButton'
import CircularProgress from '@mui/material/CircularProgress'
import { isExpired } from 'lib/utils'
import { errorObj } from '../../utils/handleError'
import { Elements } from '@stripe/react-stripe-js'
import CheckoutForm from '../../components/organisms/auth/CheckoutForm'
import { loadStripe } from '@stripe/stripe-js'
import { renderCardIcon } from '../../utils/cardIcons'

const PaymentDirectPage = () => {

  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  console.log("stripePromise")
  console.log(stripePromise)
  const [clientSecret, setClientSecret] = useState(null)
  const [setupIntentId, setSetupIntentId] = useState(null)


  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isAddCard, setIsAddCard] = useState(false)
  const token = useSelector((state) => state.subscriptions.registrationToken || localStorage.getItem('token'))
  const selectedPlan = useSelector((state) => state.subscriptions.plan)
  const discountCode = useSelector((state) => state.subscriptions.discountCode)
  const isEmpty = (obj) => Object.keys(obj).length === 0;
  const { onLogin, handleSetProfile } = useAuth()
  const login_res = location?.state?.login_res


  const [subscription, setSubscription] = useState(null)
  const [registrationToken, setRegistrationToken] = useState('')
  const [discount, setDiscount] = useState(null)
  const [plan, setPlan] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)

  const paymentValidationSchema = !isAddCard ?
    Yup.object({
      card_id: Yup.string().required(t("Required")),
      discount_code: Yup.string(),
    })
    : Yup.object({
      discount_code: Yup.string(),
    });


  const paymentValues = isAddCard ? {
    discount_code: discount || '',
  } : {
    card_id: '',
    discount_code: discount || '',
  }

  // Inizializzazione di Formik
  const formik = useFormik({
    initialValues: () => (paymentValues),
    validationSchema: () => (paymentValidationSchema),
    onSubmit: (values) => {

      const body = {
        discount_code: discount?.code,
        card_id: values.card_id

      }

      pay.mutate(body)
    },
  });

  const prepare = useMutation({
    mutationKey: 'prepare',
    mutationFn: () => preparePayment(registrationToken),
    onSuccess: async (res) => {


      setClientSecret(res?.resData?.data?.client_secret)
      setSetupIntentId(res?.resData?.data?.setup_intent_id)


    },
    onError: (err) => {
      setIsLoading(false)
      // showErrorMessage(t('error messages.Payment failed'))
    }
  })

  const cardConfirm = useMutation({
    mutationKey: 'register-card-confirm',
    mutationFn: (values) => directCardConfirm(values, (registrationToken || token)),
    onMutate: () => {
      setIsLoading(true)
    },
    onSuccess: async (res) => {


      refetchCards()
      setIsAddCard(false)


    },
    onError: (err) => {

      setIsLoading(false)
      showErrorMessage(t('error messages.Internal server error'))
    }
  })

  const pay = useMutation({
    mutationKey: 'payment-direclty',
    mutationFn: (values) => registerPaymentDireclty(values, registrationToken),
    onSuccess: async (res) => {
      setLoading(false)

      dispatch(subscriptionsActions.setRegistrationToken(res?.resData?.data?.access_token))
      localStorage.setItem('token', res?.resData?.data?.access_token)
      getUserProfile(res?.resData?.data?.access_token).then(() => {

        handleSetProfile(res?.resData?.data?.user, res?.resData?.data?.user?.role)
        onLogin(res?.resData?.data?.access_token, isAdminPage())
        navigate('/order-confirmed', { state: { login_res: login_res } })
      }, err => {

        const errObj = errorObj(err)
        showErrorMessage(t('stripe_errors.' + errObj?.resData?.errors?.[0]?.message) || t('error messages.Internal server error'))
      })

    },
    onError: (err) => {
      setLoading(false)
      const errObj = errorObj(err)
      showErrorMessage(t('stripe_errors.' + errObj?.resData?.errors?.[0]?.message) || t('error messages.Internal server error'))
    }
  })

  const { data: cards, refetch: refetchCards } = useQuery({
    queryKey: ['list-payment-cards'],
    refetchOnWindowFocus: false,
    queryFn: async () => {

      const res = await getListCompanyCards(token)
      return res?.resData?.data
    },

  });

  const [defaultCard, setAsDefaultCard] = useState('');



  const onChange = (e) => {
    setAsDefaultCard(e.target.value);

  };

  useEffect(() => {


    if (discountCode) {
      setDiscount(discountCode)
    } else {

      setDiscount(JSON.parse(localStorage.getItem('discount')))
    }
  }, [discountCode])

  useEffect(() => {
    if (discount) {
      formik.setFieldValue('discount_code', discount.code)
    }
  }, [discount])

  useEffect(() => {
    if (token && token?.length > 0) {
      localStorage.setItem('registrationToken', token)
      setRegistrationToken(token)
    } else {
      setRegistrationToken(localStorage.getItem('registrationToken'))
    }
  }, [token])

  useEffect(() => {


    if (cards && cards.length > 0) {
      setAsDefaultCard(cards[0]?.id)
    }
  }, [cards])

  useEffect(() => {
    if (login_res) {
      if (login_res?.company?.subscription?.id !== 0) {
        setSubscription(login_res?.company?.subscription)
      } else {
        const temporary_data = JSON.parse(login_res?.temporary_data)
        //   console.log('temporary_data', temporary_data);
        localStorage.setItem('plan', JSON.stringify(temporary_data?.selectedPlan))
        setPlan(temporary_data?.selectedPlan)
        setDiscount({
          code: temporary_data?.discountCode?.code,
          discount_value: temporary_data?.discountCode?.discount_value
        })
      }

    } else {
      if (!isEmpty(selectedPlan)) {
        setPlan(selectedPlan)
      } else {
        setPlan(JSON.parse(localStorage.getItem('plan')))
      }
    }
  }, [selectedPlan])

  useEffect(() => {
    if (defaultCard) {
      formik.setFieldValue('card_id', defaultCard.toString())
    }

  }, [defaultCard])

  useEffect(() => {

    if (registrationToken && registrationToken.length > 0 && isAddCard) {
      prepare.mutate()
    }

  }, [registrationToken, isAddCard])



  return (
    <div className="grid grid-cols-3 h-screen w-screen bg-[#F7F7F8] p-2">
      {/* Form */}
      <div className="col-span-2 justify-left w-full h-full bg-white rounded-2xl p-[40px]">

        {!login_res && (<p className="text-sm text-[#828282] font-normal">Step 4 {t("OF").toLowerCase()} 5</p>)}

        {!isAddCard && (
          <>
            <p className="text-3xl text-black font-semibold">{t('Pay.Title')}</p>
            <p className="text-base text-[#828282] font-normal">{t('Pay.Subtitle')}</p>
          </>
        )}


        <form onSubmit={formik.handleSubmit} className="mt-[40px]">
          {isAddCard && (

            <>
              <Elements stripe={stripePromise}>
                <CheckoutForm
                  isLoading={isLoading}
                  clientSecret={clientSecret}
                  isDirect={true}
                  closeAddCard={() => {
                    setIsAddCard(false)
                  }}
                  onSubmit={() => {

                    const body = {
                      setup_intent_id: setupIntentId,

                    }

                    cardConfirm.mutate(body)

                  }} />
              </Elements>


            </>



          )}


          {!isAddCard && (
            <>

              {cards?.length > 0 && (
                <>
                  <Radio.Group onChange={onChange} value={defaultCard}  style={{ width: '100%', marginTop: 8 }} >

                    <Space direction="vertical" className='w-full'>

                      {cards?.map((el, index) => (
                        <Card
                          key={index}
                          className={`rounded-lg transition-colors cursor-pointer ${defaultCard === el?.id ? 'bg-[#EBF1FF] border-[#0049EE]' : 'bg-white  border-[#E3E3E8]'
                          }`}
                          hoverable>
                          <Radio value={el?.id} className='w-full'>
                            <div style={{ width: '100%' }} className='flex items-center justify-between'>
                              <div className='flex items-center'>
                                {renderCardIcon(el?.card_type)}
                                <div className='ml-3'>
                                  <p className='text-black text-sm font-semibold'>{el?.card_type}</p>
                                  <p className='text-[rgba(255, 255, 255, 0.48)] text-xs font-normal'>****{el?.last_four_digit}</p>

                                  {isExpired(el?.expired_at).expired && (
                                    <div className='flex items-center'>

                                      <ErrorIcon style={{
                                        width: '15px',
                                        color: '#E53E3E'
                                      }} />

                                      <p className='text-xs font-normal text-[#E53E3E] ml-1'> {t('Pay.ExpiredAt')} {isExpired(el?.expired_at).formattedDate}</p>
                                    </div>

                                  )}

                                </div>
                              </div>



                            </div>


                          </Radio>
                        </Card>
                      ))}




                    </Space>



                  </Radio.Group>
                  <p className='mt-4 mb-4'>{t('Or')}</p>
                </>

              )}

              <CustomButton className='max-w-max' buttonColor="secondary" onClick={() => {
                setIsAddCard(true)
              }}>
                <div className='flex'>
                  <p className='mr-2'>+</p>
                  {t('Pay.AddPaymentMethod')}
                </div>

              </CustomButton>


            </>)}

          {!isAddCard && cards && cards.length > 0 && (
            <div className={`flex gap-2 pt-10 justify-end`}>
              {/* Pulsanti */}
              <div className="mt-[58px] flex justify-center">

                <Button
                  type="submit"
                  variant="contained"
                  disabled={!formik.isValid || !formik.dirty || loading}
                  sx={{
                    width: loading ? 148 : 124,
                    paddingLeft: '22px',
                    paddingRight: '22px',
                    fontWeight: 600,
                    backgroundColor: formik.isValid ? '#0049EE' : '#A0A0A0',
                    fontSize: '16px',
                    textTransform: 'none'
                  }}
                >
                  {t('Otp.Buy')}
                  {loading && (<CircularProgress size="20px" style={{ marginLeft: 8, color: 'white' }} />)}
                </Button>
              </div>
            </div>
          )}


        </form>
      </div>

      {/* Sidebar con dettagli */}
      <OrderForm showDiscount={true} login_res={login_res} />
    </div>
  );
};

export default PaymentDirectPage;
